/*
 * File: CreateOrderButton.js
 * Project: mp-mobile-app
 *
 * Created by Jennifer Loecker on 01/08/2019
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Handles the Create Order button and creating the order
 */
import React, { useState } from "react";
import Snackbar from "components/ui/UISnackbar";
import { Button, FormControl } from "@material-ui/core";
import PatientIdStorage from "../../store/PatientIdStore";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";

const styles = theme => ({
  button: {
    color: theme.palette.common.white,
    "&:enabled": {
      background: theme.palette.buttonGradient
    }
  },
  gradientBackground: {
    background: theme.palette.common.buttonGradient
  },
  buttonText: {
    color: theme.palette.common.white
  }
});

const CreateOrderButton = ({
  history,
  postChargeModel,
  classes,
  checkForError
}) => {
  const [showSnackBar, setShowSnackBar] = useState(false);
  const [chargeSuccessful, setChargeSuccessful] = useState(false);

  const createOrder = async () => {
    if (checkForError()) {
      const patientId = PatientIdStorage.getId();
      const postChargeResult = await postChargeModel.postCharge(patientId);
      if (postChargeResult === 201) {
        setShowSnackBar(true);
        setChargeSuccessful(true);
      } else {
        setShowSnackBar(true);
        setChargeSuccessful(false);
      }
      setTimeout(() => {
        history.push("/patients/" + patientId + "/patient_home");
      }, 3000);
    }
  };

  return (
    <React.Fragment>
      <FormControl fullWidth>
        <Button
          fullWidth
          color="primary"
          className={classes.button}
          variant="contained"
          onClick={createOrder}
          disabled={!postChargeModel.hasCharges}
        >
          Create Order
        </Button>
      </FormControl>
      {showSnackBar && chargeSuccessful && (
        <Snackbar
          open={showSnackBar}
          variant="success"
          message={"Billing Order Successfully Sent"}
        />
      )}
      {showSnackBar && !chargeSuccessful && (
        <Snackbar
          open={showSnackBar}
          variant="error"
          message={"Billing Order Not Successful"}
        />
      )}
    </React.Fragment>
  );
};

CreateOrderButton.propTypes = {
  classes: PropTypes.object.isRequired,
  checkForError: PropTypes.func.isRequired,
  postChargeModel: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};

export default withStyles(styles)(CreateOrderButton);
